import { css } from '@emotion/react';

export const ButtonSimple = css`
    background: none;
    padding: 0;
    text-decoration: underline;
`;
